import React from "react";
import { NavLink } from "react-router-dom";

/**
 * Sidebar — role-scoped nav injected by AppLayout via the `navItems` prop.
 * Defaults to an empty list (NOT a legacy placeholder): an unresolved/loading
 * session must never flash the old "Lessons/Bills/Planning" template nav.
 */
function Sidebar({ isOpen, navItems = [], onNavigate }) {
  return (
    <aside
      className={`app-sidebar${isOpen ? " is-open" : ""}`}
      id="sidebar"
      aria-label="Main navigation"
    >
      <ul className="nav">
        {(navItems ?? []).map(({ to, icon, label }) => (
          <li key={to} className="nav-item">
            <NavLink
              to={to}
              end={to === "/"}
              onClick={onNavigate}
              className={({ isActive }) =>
                "nav-link" + (isActive ? " active" : "")
              }
            >
              <i className={`mdi ${icon} menu-icon`} aria-hidden="true" />
              <span className="menu-title">{label}</span>
            </NavLink>
          </li>
        ))}
        <li className="nav-item border-top" role="separator" aria-hidden="true" />
      </ul>
    </aside>
  );
}

export { Sidebar };
